import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class GoogleMapsLoaderService {
  private apiLoaded = false;

  load(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.apiLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.apiLoaded = true;
        const mapLabelScript = document.createElement('script');
        mapLabelScript.src = 'assets/maplabel-compiled.js';
        mapLabelScript.onload = () => resolve();
        mapLabelScript.onerror = () => resolve();
        document.head.appendChild(mapLabelScript);
      };
      script.onerror = (err) => reject(err);

      document.head.appendChild(script);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/google-maps-loader.service.ts